import { Button } from '@talentmesh/ui/components/button';
import { ChevronLeft } from 'lucide-react';
import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import type { SelectTestsFormValues } from '../../SelectTestsStep.schema';
import UIStrings from '@/Utils/UIStrings';

export interface SelectTestsStepperNavigationButtonsProps {
    activeStep: number;
    handleBack?: () => void;
    onBackPersistTestLanguage: (testLanguage: string) => void;
    nextButtonComponent: ReactNode;
    centeredComponent: ReactNode;
}

export const SelectTestsStepperNavigationButtons = ({
    activeStep,
    handleBack,
    onBackPersistTestLanguage,
    nextButtonComponent,
    centeredComponent,
}: SelectTestsStepperNavigationButtonsProps) => {
    const { getValues } = useFormContext<SelectTestsFormValues>();

    const handleBackWrapper = () => {
        onBackPersistTestLanguage(getValues('testLanguageField'));

        if (handleBack) {
            handleBack();
        }
    };

    return (
        <div className="mt-8">
            <div className="flex flex-row items-center justify-between gap-4">
                {handleBack && (
                    <Button
                        type="button"
                        variant="outline"
                        size="default"
                        disabled={activeStep === 0}
                        onClick={handleBackWrapper}
                        className="gap-2"
                    >
                        <ChevronLeft className="size-4 shrink-0" aria-hidden />
                        {UIStrings.Back}
                    </Button>
                )}
                {centeredComponent}
                {nextButtonComponent && nextButtonComponent}
            </div>
        </div>
    );
};
